module.exports = __webpack_public_path__ + "static/media/banner-grid-02.e82ea177.jpg";